var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoListOv2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 133,
    viewBox: "0 0 194 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37451 28.02C13.6784 11.4549 31.122 1.256 49.1304 3.24756C69.3766 5.48669 84.9143 22.0859 86.1733 42.1255C93.1792 46.2603 100.771 49.4366 108.61 52.1577L115.412 54.0669C124.416 44.0702 138.056 38.8542 151.505 40.5913C180.977 44.3983 197.135 76.7251 182.558 102.623C173.079 119.464 152.788 127.481 134.373 122.04L134.281 122.013L134.191 121.98L129.898 120.408L129.58 120.291L129.295 120.106C128.861 119.824 128.367 119.566 127.746 119.259C127.169 118.974 126.418 118.616 125.708 118.214C112.856 110.939 104.896 96.9676 104.714 82.3599C104.131 82.07 103.571 81.7987 103.402 81.7183C94.592 77.5274 84.9935 74.5762 75.3501 72.8599C75.192 73.0384 75.0349 73.2183 74.8823 73.3921C74.7811 73.5073 74.6786 73.6226 74.5874 73.7241C74.5049 73.8159 74.3959 73.9368 74.2896 74.0435L74.2886 74.0444C64.3068 84.0486 49.9997 88.5273 36.0464 85.5464C35.401 85.4086 34.7272 85.2203 34.2505 85.0962C33.72 84.9581 33.3126 84.8653 32.9409 84.8169L32.6099 84.7739L32.2964 84.6587L28.2563 83.1792L27.9077 83.0513L27.6011 82.8433C27.338 82.6644 27.0131 82.4913 26.5464 82.2671C26.1407 82.0722 25.5026 81.7811 24.9351 81.4741V81.4751C9.35615 73.0522 0.657839 55.5291 3.55225 37.9956L3.56104 37.937L3.57373 37.8784L4.56885 33.0532L4.62842 32.7671L4.74072 32.4976C4.98653 31.9122 5.19693 31.2756 5.4585 30.4897C5.70465 29.7502 5.99953 28.8705 6.37451 28.02Z",
    fill: "#FF7506",
    stroke: "#FAFAFA",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_13",
    x: 0,
    y: 0,
    width: 194.005,
    height: 132.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_13",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoListOv2);
export default __webpack_public_path__ + "static/media/info-list-ov-2.bfc341f8857f15c7352b53ef3ffd0e83.svg";
export { ForwardRef as ReactComponent };